export default function(email) {
  const adminEmails =
    process.env.REACT_APP_ADMIN_AVAILABLE_EMAILS &&
    process.env.REACT_APP_ADMIN_AVAILABLE_EMAILS.split(' ');
  return adminEmails ? adminEmails.find(e => e === email) : false;
}
